import {useLocation, useNavigate} from "react-router-dom";
import React, {useEffect, useMemo, useState} from "react";
import {EditLocalStoragePagesData} from "../../../utils/EditLocalStoragePagesData";
import Box from "@mui/material/Box";
import {
    Button,
    Checkbox,
    Chip,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Select, Tooltip, tooltipClasses,
    Typography
} from "@mui/material";
import ButtonCreate from "../../../components/UI/button/ButtonCreate";
import {
    MaterialReactTable,
    MRT_GlobalFilterTextField,
    MRT_ToggleFiltersButton,
    MRT_ToolbarAlertBanner
} from "material-react-table";
import MenuItem from "@mui/material/MenuItem";
import {MRT_Localization_RU} from "material-react-table/locales/ru";
import Radio from "@mui/material/Radio";
import SelcoFileFieldsService from "../../../API/organization/SelcoFileFieldsService";
import ButtonExit from "../../../components/UI/button/ButtonExit";
import ButtonAdd from "../../../components/UI/button/ButtonAdd";
import TextFieldValidation from "../../../components/UI/table/customer-detales/TextFieldValidation";
import {materialCutDefault} from "../../../data/MaterialCutDefault";
import {detailField} from "../../../data/DetailField";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import {styled} from "@mui/system";
import SelcoFileFieldsModal from "../../../components/UI/modal/SelcoFileFieldsModal";
import ButtonText from "../../../components/UI/button/ButtonText";
import ButtonBlue from "../../../components/UI/button/ButtonBlue";


const SelcoFileFields = ({
                             itemId, handleModalAlert, isModal, selectedString,
                             setSelectedString,
                         }) => {
    const api = SelcoFileFieldsService
    const pathname = useLocation().pathname
    const [data, setData] = useState([])
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 100,
        totalElements: 0,
        searchData: ""
    })
    const [loading, setLoading] = useState(false)

    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
        if (nextState.pageSize !== tableOptions.pageSize) {
            EditLocalStoragePagesData(`${pathname}+${itemId}`, "pageSize", nextState.pageSize)
        }
    }

    const getStartPageSize = () => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const pageSize = pagesData[`${pathname}+${itemId}`]?.pageSize
        pageSize && setTableOptions((prev) => ({...prev, pageSize: pageSize}))
    }

    useEffect(() => {
        getStartPageSize()
        api.get().then(function (response) {
            let data = response.data;
            setData(data);
            setTableOptions((prev) => ({...prev, totalElements: response?.data.length}))
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    }, [])

    const [modalOpen, setModalOpen] = useState(false);
    const [currentEditRowData, setCurrentEditRowData] = useState(null);

    const handleEditRow = (row) => {
        setCurrentEditRowData(row);
        setModalOpen(true)
    }
    const handleClose = () => {
        setModalOpen(false)
        setCurrentEditRowData(null)
    }
    const handleEditDefault = (id) => {
        api.editDefault(id)
            .then(function (response) {
                setData(prev => prev.map(el => el.id === id ? {...el, defaultOrder: true} : {
                    ...el,
                    defaultOrder: false
                }))
                handleModalAlert("Данные изменены", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error)
            })
        handleClose()
    }

    const handleSubmit = (values, close) => {
        setLoading(true)
        api.save(values).then(function (response) {
            setData(prev => [...prev, response.data])
            tableOptionsHandle((prev) => ({...prev, totalElements: data.length + 1}))
            close()
            handleModalAlert("Данные добавлены", 'success')
        })
            .catch(function (error) {
                handleModalAlert(error)
            })
            .finally(() => setLoading(false))
    };

    const handleEdit = (values, close) => {
        setLoading(true)
        api.edit(values).then(function (response) {
            setData(prev => prev.map(el => el.id === values.id ? response.data : el))
            tableOptionsHandle((prev) => ({...prev, totalElements: data.length + 1}))
            close()
            handleModalAlert("Данные изменены", 'success')
        })
            .catch(function (error) {
                handleModalAlert(error)
            })
            .finally(() => setLoading(false))
    };

    const handleDeleteRow = (row) => {
        api.delete(row.id)
            .then(function (response) {
                const newDefaultId = response.data
                setData(prev => prev.filter(el => el.id !== row.id).map(el => newDefaultId && el.id === newDefaultId ? {
                    ...el,
                    defaultOrder: true
                } : el))
                tableOptionsHandle((prev) => ({...prev, totalElements: data.length - 1}))
                handleModalAlert("Данные удалены", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error)
            })
    };

    const columns = useMemo(
        () => [
            {
                id: 'name',
                header: 'Наименование',
                accessorKey: 'name',
                size: 510,
                grow: true,
                Cell: ({cell, row}) => {
                    const data = row.original

                    return <Box sx={{display: "flex", alignItems: "center"}}>
                        {data.fields.map((el, i) => <>
                                <Chip label={detailField[el]}/>
                                <Typography sx={{width: "5px"}}>{data.separators[i] || " "}</Typography>
                            </>
                        )}
                    </Box>
                },
            },
            {
                header: 'Дефолтный',
                accessorKey: 'defaultOrder',
                size: 8,
                grow: false,
                Cell: ({cell, row}) => <Radio
                    cell={cell}
                    checked={row.original.defaultOrder}
                    onClick={() => handleEditDefault(row.original.id)}
                    sx={{padding: "7px", '& .MuiSvgIcon-root': {fontSize: 22}}}
                >
                </Radio>,
            },
        ],
        [data, setData],
    );
    const menuItem = [
        {type: "edit", text: "Изменить", handler: handleEditRow},
        {type: "delete", text: "Удалить", handler: handleDeleteRow}
    ]
    const navigate = useNavigate();

    const redirectSettingsSelcoFields = () => {
        const pathname = "/settings"
        EditLocalStoragePagesData(pathname, "settingName", "selcoFileFields")
        EditLocalStoragePagesData(pathname, "expanded", [
            "BiesseSettings",
            "CuttingSettings",
            "CNCSettings",
            "adress",
            "settings"
        ])
        navigate(pathname);
    }

    return (
        <div>
            < Box
                sx={{display: 'flex', justifyContent: "space-between", paddingBottom: "30px", gap: "16px"}}>
                {!isModal &&
                    <Typography sx={{fontSize: "24px", fontWeight: 700}}>Порядок экспорта полей Selco</Typography>}
                {!isModal && <ButtonCreate
                    text={"Создать"}
                    width={130}
                    onClick={() => setModalOpen(true)}
                />}
            </Box>
            {isModal && data.length === 0 ?
                <Box sx={{display: "flex", alignItems: "center", gap: "10px"}}>
                    <Typography> Для экспорта </Typography>
                    <ButtonBlue width={230}
                                text={"добавьте порядок полей"}
                                onClick={redirectSettingsSelcoFields}/></Box> :
                <MaterialReactTable
                    renderTopToolbar={({table}) => {
                        return <Box sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            padding: "7px",
                            backgroundColor: (theme) => table.getSelectedRowModel().rows.length > 0 ? theme.palette.primary.light : "transparent",
                        }}>
                            <MRT_ToolbarAlertBanner table={table}/>
                            <Box sx={{display: "flex"}}>
                                <MRT_ToggleFiltersButton table={table}/>
                                <MRT_GlobalFilterTextField table={table}/>
                            </Box>
                        </Box>
                    }}
                    selectAllMode={"all"}
                    muiTableContainerProps={{
                        sx: {
                            width: '750px',
                            maxHeight: `calc(100vh - 420px)`
                        }
                    }}
                    muiTableBodyCellProps={{
                        sx: {
                            p: '0px 0px 0px 10px',
                            m: '0px 0px 0px 0px',
                            border: "none",
                            "&:after": {
                                display: "none",
                            },
                            "& td:after": {
                                "&:hover": {
                                    backgroundColor: "red"
                                }
                            },
                            "&:not(:last-of-type)": {
                                borderRight: '1px solid #EAEBEA',

                            },
                            "&:last-of-type": !isModal && {
                                padding: 0,
                                width: 'calc(100% - 1px)',
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            },
                            "&:first-of-type": !isModal && {
                                padding: 0,
                                width: "50px",
                                height: "36px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                color: (theme) => theme.palette.text.light,
                                "& .MuiButtonBase-root": {
                                    borderRadius: "4px",
                                    width: "24px",
                                    height: "24px",
                                    opacity: 1,
                                    margin: 0,
                                    padding: 0,
                                    "&:hover": {
                                        backgroundColor: (theme) => theme.palette.primary.stroke,
                                    }
                                }
                            },
                            "& li": {
                                listStyleType: "none",
                                "& a": {
                                    color: "#006CCC",
                                    textDecoration: "none",
                                    "&:hover": {
                                        textDecoration: "underline"
                                    }
                                }
                            }
                        },
                    }}
                    muiTableHeadCellProps={{
                        sx: {
                            border: '1px solid #EAEBEA',
                            backgroundColor: "#F5F6FA",
                            padding: "10px",
                            paddingBottom: " 0.2rem",
                            paddingTop: "0.2rem"
                        },
                    }}
                    muiTableBodyRowProps={({row}) => {
                        return ({
                            onClick: () => isModal && setSelectedString(row.original),
                            sx: () => ({
                                height: '36px',
                                cursor: isModal && "pointer",
                                "&:hover& td:after": {
                                    display: "none",
                                },
                                '&:nth-of-type(even)': {
                                    backgroundColor: row.original.id === selectedString?.id ? (theme) => theme.palette.primary.light : (theme) => theme.palette.primary.lightGrey,
                                    "&.MuiTableRow-root.Mui-selected": {
                                        backgroundColor: (theme) => theme.palette.primary.light,
                                        "&:hover": {
                                            backgroundColor: (theme) => theme.palette.primary.light50,
                                        },
                                    },
                                    "&:hover": {
                                        backgroundColor: row.original.id === selectedString?.id ? (theme) => theme.palette.primary.light50 : (theme) => theme.palette.primary.stroke,
                                    },
                                },
                                backgroundColor: row.original.id === selectedString?.id ? (theme) => theme.palette.primary.light : "white",
                                "&:hover": {
                                    backgroundColor: row.original.id === selectedString?.id ? (theme) => theme.palette.primary.light50 : (theme) => theme.palette.primary.stroke,
                                },
                                "&.MuiTableRow-root.Mui-selected": {
                                    backgroundColor: (theme) => theme.palette.primary.light70,
                                    "&:hover": {
                                        backgroundColor: (theme) => theme.palette.primary.light50,
                                    },
                                },
                            })
                        })
                    }}

                    displayColumnDefOptions={{
                        'mrt-row-actions': {
                            header: "",
                            size: 3,
                            minSize: 3,
                            grow: false,
                        },
                    }}
                    muiSearchTextFieldProps={{
                        placeholder: `Поиск`,
                        sx: {
                            paddingTop: "5px",
                            paddingBottom: "0px",
                            "& .MuiCollapse-root": {
                                borderRadius: '12px',
                                height: 40, width: 290,
                                "& .MuiSvgIcon-root": {
                                    color: "#737478"
                                },
                                '& .MuiOutlinedInput-input': {
                                    padding: 0
                                }
                            }
                        },
                        variant: 'outlined',
                    }}
                    state={{showGlobalFilter: true, pagination: tableOptions,}}
                    columns={columns}
                    data={data || []}
                    renderRowActionMenuItems={({closeMenu, row}) => menuItem.map(el => {
                        return <MenuItem
                            key={el.type}
                            onClick={() => {
                                el.handler(row.original)
                                closeMenu();
                            }}
                            sx={{
                                margin: "0 8px",
                                borderRadius: "4px",
                                "&:hover": {backgroundColor: (theme) => theme.palette.primary.light}
                            }}
                        >
                            {el.text}
                        </MenuItem>
                    })}
                    initialState={{
                        sorting: [{id: 'name', desc: false}],
                        columnVisibility: {
                            id: false,
                            active: !isModal,
                            defaultOrder: !isModal
                        },
                        isFullScreen: false,
                        density: "compact",
                        pagination: {pageIndex: 0, pageSize: 100},
                        columnPinning: {left: ['number']}
                    }}
                    onPaginationChange={(updater) => {
                        tableOptionsHandle(updater(tableOptions));
                    }}
                    rowCount={tableOptions.totalElements}
                    localization={MRT_Localization_RU}
                    enableToolbarInternalActions={false}
                    enableRowActions={!isModal}
                    enableColumnActions={false}

                />}

            <SelcoFileFieldsModal
                open={modalOpen}
                onClose={handleClose}
                initValue={currentEditRowData}
                handleSubmit={currentEditRowData ? handleEdit : handleSubmit}
                loading={loading}
            />
        </div>
    );
};

export default SelcoFileFields;